import styled from '@emotion/styled/macro';

export const Modal = styled.div`
    position: fixed;
    background-color: rgba(235, 235, 235, 1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 100vh;
    z-index: 1;
`;

export const ModalContent = styled.div`
    width: 85%;
`;

export const Heading = styled.h2`
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.xlarge};
    color: ${props => props.theme.colours.textGreen};
    margin-bottom: ${props => props.theme.spacing.xxlarge};
    line-height: 28px;
    text-align: center;
    text-transform: uppercase;
`;
